import MerchCatalogue from "../components/merchandise/catalogue/merchCatalogue";
import { Hero } from "../layouts/hero";
import { MainLayout } from "../layouts/mainLayout";

function Merchendise() {
  return (
    <MainLayout>
      <div className="main">
        <Hero
          title="Merchandise"
          logo={false}
          desc="View and manage the current merchandise catalogue."
        />
        <MerchCatalogue />
      </div>
    </MainLayout>
  );
}

export default Merchendise;
